import React, { Component } from 'react';
import Icon from './Icon';
import ToolTip from './ToolTip';

class Accessibility extends Component {
  render() {
    const { types } = this.props;

    return (
      <div className="accessibility__wrapper">
        {types.map((type, index) => {
          return <AccessibilityIcon type={type} key={`${index}${type}`} />;
        })}
      </div>
    );
  }
}

class AccessibilityIcon extends Component {
  render() {
    const { type } = this.props;
    let content, icon, accessible;
    switch (type) {
      case 'wheelchair-yes':
        content = 'Toegankelijk voor personen met een mobiele beperking';
        icon = 'wheelchair';
        accessible = true;
        break;

      case 'wheelchair-no':
        content = 'Niet toegankelijk voor personen met een mobiele beperking';
        icon = 'wheelchair';
        accessible = false;
        break;

      case 'blind-yes':
        content = 'Toegankelijk voor personen met een visuele beperking';
        icon = 'blind';
        accessible = true;
        break;

      case 'blind-no':
        icon = 'blind';
        accessible = false;
        content = 'Niet toegankelijk voor personen met een visuele beperking';
        break;

      default:
        content = '';
        icon = '';
        break;
    }

    if (content && icon) {
      const classNames = [
        'accessibility__icon'
      ];
      if (!accessible) {
        classNames.push('accessibility__icon--not');
      }
      return (
        <ToolTip className={classNames.join(' ')} placement="auto-end" content={content}>
          <Icon iconName={icon} />
        </ToolTip>
      );
    }
  }
}
export default Accessibility;



// WEBPACK FOOTER //
// ./src/components/Common/Accessibility.js